export const checkDeviceIOS = () => {
  const userAgent = navigator.userAgent;
  if (
    userAgent.indexOf('iPhone') > -1 ||
    userAgent.indexOf('iPad') > -1 ||
    userAgent.indexOf('iOS') > -1 ||
    userAgent.indexOf('iPod') > -1) {
    return true;
  }
  return false;
};

export const checkDeviceAndroid = () => {
  const userAgent = navigator.userAgent;
  return userAgent.indexOf('Android') > -1;
};

export const checkUserAgentCustom = () => {
  const userAgent = navigator.userAgent;
  const USER_AGENT_PREFIXES = ['tbxandroidapp', 'tbxiosapp'];
  const result = USER_AGENT_PREFIXES.some(prefix => userAgent.startsWith(prefix));

  return !!result;
};

export const isMobileDevice = () => {
  return checkDeviceIOS() || checkUserAgentCustom() || checkDeviceAndroid();
};

export const USER_AGENT_TBX_PREFIXES = {
  android: 'tbxandroidapp',
  ios: 'tbxiosapp'
};

export const checkUserAgentByPrefix = (prefix) => {
  const userAgent = navigator.userAgent;

  const result = userAgent.startsWith(prefix);

  return !!result;
};


export const cleanInputs = (input) => {
  if (typeof input === 'string' || input instanceof String) {
    const inputTrimmed = input.replace(/ /g, '');
    return inputTrimmed;
  }
};

export const validateEmail = (username) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(username);
};

export const isInvalidCredentialsError = (error) => {
  const codes = ['SM-SKY-010', 'SM-SKY-013'];
  return error && error.code && codes.includes(error.code);
};

export const isMaxAttemptsError = (error) => {
  const codes = ['SM-SKY-105', 'SKY-107', 'SM-SKY-110'];
  return error && error.code && codes.includes(error.code);
};

export const isMaxLoginAttemptsError = (error) => {
  const codes = ['SM-SKY-105'];
  return error && error.code && codes.includes(error.code);
};

export const isOtpCodeError = (error) => {
  const codes = ['SM-SKY-011', 'SM-SKY-012'];
  return error && error.code && codes.includes(error.code);
};

export const isSkyInterruptedAuthError = (error) => {
  // custom modal from sky api
  return error && error.code && error.code === 'SKY-105';
};
